import classnames from 'classnames';

import { useNavigate } from 'react-router-dom';
import { DataSourceOrganization } from 'src/types/data-sources';

export const DataSourceCard = ({ dataSource }: { dataSource: DataSourceOrganization }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`data-sources/${dataSource.dataSourceId}`);
  };

  return (
    <div
      key={dataSource.dataSourceId}
      className={classnames(
        'flex flex-col items-start w-[412px]  px-4 py-6 rounded gap-4 cursor-pointer',
        'bg-gray-900  border-sm border border-gray-800 hover:bg-gray-800 line-clamp-1',
      )}
      onClick={handleClick}
    >
      <div className="flex items-start flex-col gap-1">
        <span className="text-gray-500 text-sm">{dataSource.organizationName}</span>
        <span className="text-white font-bold line-clamp-1">{dataSource.dataSourceName}</span>
      </div>
    </div>
  );
};
